import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Box, Skeleton, useTheme } from '@mui/material'; // استيراد useTheme
import TransferForm from './TransferForm';
import TransferHistory from './TransferHistory';
import TopNav from './TopNav';
import { getTransferHistory, fetchWallet, fetchWalletIds } from '../../store/Slices/assetSlice';

const TransferSection = () => {
  const dispatch = useDispatch();
  const theme = useTheme(); // جلب الثيم
  const { transferHistory, walletInitialized, walletIds, loading, error } = useSelector((state) => state.assets);
  const userId = useSelector((state) => state.user.data._id);

  useEffect(() => {
    if (!walletInitialized) {
      dispatch(fetchWallet());
    }
    dispatch(fetchWalletIds(userId));
    dispatch(getTransferHistory(userId));
  }, [dispatch, userId, walletInitialized]);

  if (loading) {
    return (
      <Box sx={{ bgcolor: theme.palette.background.default }}>
        <TopNav title="Transfer" />
        <Box sx={{ mt: 3, px: 2 }}>
          <Box sx={{ mb: 3 }}>
            <Skeleton variant="rectangular" height={40} sx={{ mb: 2, borderRadius: 2 }} />
            <Skeleton variant="rectangular" height={56} sx={{ mb: 2, borderRadius: 2 }} />
            <Skeleton variant="rectangular" height={56} sx={{ mb: 2, borderRadius: 2 }} />
            <Skeleton variant="rectangular" height={80} sx={{ mb: 2, borderRadius: 2 }} />
            <Skeleton variant="rectangular" height={48} sx={{ borderRadius: 2 }} />
          </Box>
          <Box>
            <Skeleton variant="rectangular" height={40} sx={{ mb: 2, borderRadius: 2 }} />
            <Skeleton variant="rectangular" height={200} sx={{ borderRadius: 2 }} />
          </Box>
        </Box>
      </Box>
    );
  }

  if (error) {
    return (
      <Box sx={{ bgcolor: theme.palette.background.default, minHeight: '100vh', p: 2 }}>
        <TopNav title="Transfer" />
        <Box sx={{ color: theme.palette.text.primary }}>Error: {error}</Box>
      </Box>
    );
  }

  if (!walletIds.spotWalletId || !walletIds.futuresWalletId || !walletIds.aiWalletId) {
    return (
      <Box sx={{ bgcolor: theme.palette.background.default, minHeight: '100vh', p: 2 }}>
        <TopNav title="Transfer" />
        <Box sx={{ color: theme.palette.text.primary }}>Failed to load wallet IDs</Box>
      </Box>
    );
  }

  return (
    <Box sx={{ bgcolor: theme.palette.background.default, minHeight: '100vh' }}>
      <TopNav title="Transfer" />
      <Box sx={{ mt: 3, px: 2 }}>
        <TransferForm
          userId={userId}
          spotWalletId={walletIds.spotWalletId}
          futuresWalletId={walletIds.futuresWalletId}
          aiWalletId={walletIds.aiWalletId}
        />
        <TransferHistory
          transferHistory={transferHistory}
          spotWalletId={walletIds.spotWalletId}
          futuresWalletId={walletIds.futuresWalletId}
          aiWalletId={walletIds.aiWalletId}
        />
      </Box>
    </Box>
  );
};

export default TransferSection;